import type { ReactNode } from "react";
import { RequireAcl } from "@/components/RequireAcl";

export function RequireNachunternehmerAccess({ children }: { children: ReactNode }) {
  return <RequireAcl href="/nachunternehmer.html">{children}</RequireAcl>;
}
